module.exports = __webpack_public_path__ + "img/tick-icon-circle.53e75b30.png";